var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.load)?_c('div',{staticClass:"preloader"},[_c('img',{staticClass:"preloader__icon",attrs:{"src":require("@/assets/img/preloader.svg"),"alt":"loading..."}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }